var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polyline, _polyline2, _line, _line2, _path, _path2, _path3, _path4, _path5, _path6, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _polygon8, _line23, _line24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpBookletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f,.g{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.c,.d,.e,.f,.h{fill-rule:evenodd;}.c,.h{fill:#89d9fb;}.d{fill:#ffefe0;}.e{fill:#fff;}.f,.g,.h{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-booklet-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "21.45 120.84 56.48 100.62 56.48 100.62 91.52 120.84 126.55 100.62 126.55 45.16 91.52 65.38 56.48 45.16 56.48 45.16 21.45 65.38 21.45 120.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "13.45 79.11 48.48 58.89 48.48 19.16 13.45 39.38 13.45 79.11"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "83.52 39.38 118.55 19.16 118.55 98.62 83.52 118.84 83.52 39.38"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "13.45 118.84 48.48 98.62 48.48 58.89 13.45 79.11 13.45 118.84"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "48.48 98.62 83.52 118.84 83.52 39.38 48.48 19.16 48.48 98.62"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "83.52 110.84 48.48 90.62 48.48 66.38 83.52 86.61 83.52 110.84"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "48.48 98.62 83.52 118.84 83.52 39.38 48.48 19.16 48.48 98.62"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "83.52 39.38 118.55 19.16 118.55 98.62 83.52 118.84"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "48.48 19.16 13.45 39.38 13.45 118.84 48.48 98.62"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 19.04,
    y1: 45.62,
    x2: 42.9,
    y2: 31.84
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 19.04,
    y1: 51.62,
    x2: 42.9,
    y2: 37.84
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M93.75,41.79c2.57-1.48,4.65-.45,4.65,2.31a9.94,9.94,0,0,1-4.65,7.69c-2.57,1.48-4.65.45-4.65-2.31A9.94,9.94,0,0,1,93.75,41.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.89,39,113,33.2M102.89,44,113,38.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M93.75,57.79c2.57-1.48,4.65-.45,4.65,2.31a9.94,9.94,0,0,1-4.65,7.69c-2.57,1.48-4.65.45-4.65-2.31A9.94,9.94,0,0,1,93.75,57.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.89,55,113,49.2M102.89,60,113,54.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M93.75,73.79c2.57-1.48,4.65-.45,4.65,2.31a9.94,9.94,0,0,1-4.65,7.69c-2.57,1.48-4.65.45-4.65-2.31A9.94,9.94,0,0,1,93.75,73.79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.89,71,113,65.2M102.89,76,113,70.2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 77.93,
    y1: 52.16,
    x2: 54.07,
    y2: 38.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 77.93,
    y1: 46.16,
    x2: 64.93,
    y2: 38.65
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 61.04,
    y1: 36.4,
    x2: 54.07,
    y2: 32.38
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 58.41,
    y1: 46.89,
    x2: 54.07,
    y2: 44.38
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 77.93,
    y1: 58.16,
    x2: 70.17,
    y2: 53.68
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 66.54,
    y1: 51.58,
    x2: 62.2,
    y2: 49.07
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 42.9,
    y1: 85.84,
    x2: 19.04,
    y2: 99.62
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 42.9,
    y1: 91.84,
    x2: 29.9,
    y2: 99.35
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 26,
    y1: 101.6,
    x2: 19.04,
    y2: 105.62
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 23.38,
    y1: 91.11,
    x2: 19.04,
    y2: 93.62
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 42.9,
    y1: 79.84,
    x2: 35.14,
    y2: 84.32
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 31.51,
    y1: 86.42,
    x2: 27.17,
    y2: 88.93
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 54.07,
    y1: 56.38,
    x2: 77.93,
    y2: 70.16
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 54.07,
    y1: 50.38,
    x2: 67.07,
    y2: 57.89
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 70.97,
    y1: 60.14,
    x2: 77.93,
    y2: 64.16
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 112.96,
    y1: 91.84,
    x2: 89.1,
    y2: 105.62
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 93.44,
    y1: 97.11,
    x2: 89.1,
    y2: 99.62
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 112.96,
    y1: 85.84,
    x2: 105.2,
    y2: 90.32
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 101.57,
    y1: 92.42,
    x2: 97.23,
    y2: 94.93
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 13.45,
    y1: 79.11,
    x2: 48.48,
    y2: 58.89
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "48.48 98.62 57.73 103.96 57.73 24.5 48.48 19.16 48.48 98.62"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 83.52,
    y1: 86.61,
    x2: 48.48,
    y2: 66.38
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 83.52,
    y1: 110.84,
    x2: 48.48,
    y2: 90.62
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBookletIcon);
export default __webpack_public_path__ + "static/media/CP-booklet-icon.425afead0aaf5fd7a87ec34afa75673a.svg";
export { ForwardRef as ReactComponent };